<template>
  <v-app>
    <slot
      v-bind="{
        updatePage, updating, handleFiltersInit, mapUrl, count,
      }"
    />
  </v-app>
</template>

<script>
import {
  axiosClient,
  setDocumentTitle,
  replaceInnerHtml,
  scrollTo,
  getElementOffsetTop,
  dispatchCustomEventGlobally,
} from 'www/utils'
import { SCROLL_TO_OPTIONS } from 'www/constants/filtersData'
import ServiceFiltersUrlGeneratingMixin from 'www/vue_components/common/ServiceFilters/mixins/ServiceFiltersUrlGeneratingMixin'
import FiltersPaginationMixin from 'www/vue_components/common/Filters/mixins/FiltersPaginationMixin'

export default {
  name: 'ServiceFiltersPageManager',
  mixins: [
    ServiceFiltersUrlGeneratingMixin,
    FiltersPaginationMixin,
  ],
  props: {
    initialCount: {
      type: [Number, String],
      default: null,
    },
    domNodes: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      updating: false,
      mapUrl: this.baseMapPath,
      count: this.initialCount,
    }
  },
  mounted() {
    this.scrollTarget = document.querySelector(this.domNodes.scrollTarget)
  },
  methods: {
    handleFiltersInit(filters) {
      this.updateMapUrl(filters)
    },
    updatePage(filters) {
      this.populatePageWithNewData(this.generateUrlFromFilter(filters), filters)
      this.updateMapUrl(filters)
    },
    updateMapUrl(filters) {
      this.mapUrl = this.generateMapUrl(filters)
    },
    async populatePageWithNewData(url) {
      this.updating = true

      window.history.replaceState(window.history.state, null, url)

      const data = await axiosClient.get(url)
        .then(res => res.data)
        .catch(err => {
          // eslint-disable-next-line no-console
          console.error(err)
        })

      if (!data) {
        return
      }

      replaceInnerHtml(this.domNodes.list, data.appointments_page)
      replaceInnerHtml(this.domNodes.servicesListInfo, data.information)
      replaceInnerHtml(this.domNodes.head, data.head)
      replaceInnerHtml(this.domNodes.pagination, data.paginator)
      replaceInnerHtml(this.domNodes.bread, data.bread)
      replaceInnerHtml(this.domNodes.seoH1Description, data.seo_h1_description)

      if (data.lpu_ad) {
        replaceInnerHtml(this.domNodes.lpuAd, data.lpu_ad)

        dispatchCustomEventGlobally('executeLpuAdScript')
      }

      this.count = data.count

      setDocumentTitle(data.title)
      scrollTo(getElementOffsetTop(this.scrollTarget), SCROLL_TO_OPTIONS)

      document.dispatchEvent(new Event('refresh_slots'))
      document.dispatchEvent(new Event('refreshInit'))
      document.dispatchEvent(new Event('initSlider'))
      document.dispatchEvent(new Event('content-replace'))
      document.dispatchEvent(new Event('set_toggle_action'))
      document.dispatchEvent(new Event('get-doctor-spec'))
      document.dispatchEvent(new Event('updateLpuSchedule'))

      document.dispatchEvent(new Event('mountLpuLoyaltyProgram'))

      this.updating = false
    },
  },
}
</script>

<style>
#app {
  background-color: transparent;
  -webkit-text-size-adjust: none;
  -webkit-overflow-scrolling: touch;
}

#app .v-application--wrap {
  min-height: auto;
}

#app input {
  height: auto;
  border: none;
  border-radius: 0;
  padding: initial;
}
</style>
